import { onKey } from "./onKey.js";

function normalizeSectionOptions(options = []) {
  return Array.isArray(options) ? options.filter((option) => option && typeof option.value !== "undefined") : [];
}

export function createSectionNavigationBindings({
  options = [],
  value,
  onChange,
  previousBinding = "Alt+PageUp",
  nextBinding = "Alt+PageDown",
  allowInInput = false
} = {}) {
  const normalizedOptions = normalizeSectionOptions(options);
  if (normalizedOptions.length < 2 || typeof onChange !== "function") {
    return [];
  }

  const currentIndex = normalizedOptions.findIndex((option) => option.value === value);
  const resolvedIndex = currentIndex >= 0 ? currentIndex : 0;

  function move(direction) {
    const nextIndex = (resolvedIndex + direction + normalizedOptions.length) % normalizedOptions.length;
    const nextOption = normalizedOptions[nextIndex];
    if (!nextOption) {
      return;
    }

    onChange(nextOption.value, nextOption);
  }

  return [
    onKey(previousBinding, () => {
      move(-1);
    }, { allowInInput }),
    onKey(nextBinding, () => {
      move(1);
    }, { allowInInput })
  ];
}
